import axios from './axiosConfig';
import { API_URL } from '../config';
import type { User } from './UserService';

export interface CampaignPayload {
  name: string;
  dashboard_url: string;
  platform_id: string;
  matomo_id: string;
  primary_color?: string;
  secondary_color?: string;
  chatbot_enabled?: boolean;
  start_date?: string | null;
  end_date?: string | null;
}

export interface Campaign {
  id: number;
  name: string;
  dashboard_url: string;
  matomo_id: string;
  platform_id: string;
  primary_color?: string;
  secondary_color?: string;
  chatbot_enabled: boolean;
  created_at: string;
  start_date?: string | null;
  end_date?: string | null;
}

export interface CampaignDailyGoal {
  id: number;
  campaign_id: number;
  goal_date: string;
  registrations_goal: number;
  coupons_goal: number;
  participants_goal: number;
  created_at?: string;
  updated_at?: string;
}

export interface CampaignDailyGoalPayload {
  goal_date: string;
  registrations_goal: number;
  coupons_goal: number;
  participants_goal: number;
}

export const CampaignService = {
  list: async (): Promise<Campaign[]> => {
    const response = await axios.get(`${API_URL}/admin/campaigns`);
    return response.data.items;
  },

  create: async (payload: CampaignPayload): Promise<Campaign> => {
    const response = await axios.post(`${API_URL}/admin/campaigns`, payload);
    return response.data;
  },

  assignUsers: async (campaignId: number, userIds: number[]): Promise<void> => {
    await axios.post(`${API_URL}/admin/campaigns/${campaignId}/users`, { user_ids: userIds });
  },

  setChatbotEnabled: async (campaignId: number, chatbotEnabled: boolean): Promise<Campaign> => {
    const response = await axios.put(`${API_URL}/admin/campaigns/${campaignId}/chatbot`, {
      chatbot_enabled: chatbotEnabled,
    });
    return response.data;
  },

  updateDates: async (
    campaignId: number,
    data: { start_date?: string | null; end_date?: string | null; primary_color?: string; secondary_color?: string }
  ): Promise<Campaign> => {
    const response = await axios.put(`${API_URL}/admin/campaigns/${campaignId}`, data);
    return response.data;
  },

  getDailyGoals: async (campaignId: number): Promise<CampaignDailyGoal[]> => {
    const response = await axios.get(`${API_URL}/admin/campaigns/${campaignId}/goals`);
    return response.data.items;
  },

  updateDailyGoals: async (
    campaignId: number,
    goals: CampaignDailyGoalPayload[]
  ): Promise<CampaignDailyGoal[]> => {
    const response = await axios.put(`${API_URL}/admin/campaigns/${campaignId}/goals`, {
      goals,
    });
    return response.data.items;
  },

  getUsers: async (campaignId: number): Promise<User[]> => {
    const response = await axios.get(`${API_URL}/admin/campaigns/${campaignId}/users`);
    return response.data.items;
  },
};
